import { getMeasurementData } from './getMeasurementData';
import { getMeasurementsList } from './getMeasurementList';

export interface IMeasurement {
  getMeasurementData: typeof getMeasurementData;
  getMeasurementsList: typeof getMeasurementsList;
}

/**
 * @namespace
 */
const Measurement: IMeasurement = {
  getMeasurementData,
  getMeasurementsList,
};

export default Measurement;
